import { getAnnualMonthlyEquivalent } from "./membership-plan-defaults";
import { formatPrice } from "./stripe/helpers";

/**
 * Price line shown on content paywalls. Uses the yearly plan, which carries
 * no joining fee, so it is accurate in every joining-price arm.
 *
 * @param options.yearlyAmount - Yearly membership price in major units
 * @param options.currency - Display currency, USD when missing
 * @returns The line, or null when there is no usable yearly price
 */
export const getPaywallPriceLine = (options: {
	yearlyAmount: number;
	currency?: string | null;
}): string | null => {
	if (!Number.isFinite(options.yearlyAmount) || options.yearlyAmount <= 0) {
		return null;
	}

	const monthly = formatPrice({
		currency: options.currency,
		value: getAnnualMonthlyEquivalent(options.yearlyAmount),
	});

	return `Membership from ${monthly}/month, billed yearly. Cancel anytime.`;
};
